//VITE dev mode check
window.META_ENV = {DEV: import.meta.env.DEV}
window.BASE_HOST = window.location.origin
window.API_HOST = constructNewUrl(import.meta.env.VITE_API_HOST_PROTO, import.meta.env.VITE_API_HOST_DOMAIN)

window.sentryEnabled = import.meta.env.VITE_SENTRY_ENABLED === "true";

//attach axios instance to window
import axios from './axios'
import { v4 as uuidv4 } from 'uuid'
// Object.defineProperty(axios, "baseURL", {
//     get: () => window.API_HOST || 'x.com'
// });
axios.defaults.baseURL = API_HOST
window.axios = axios;

window.API_AUTH_TOKEN = axios.defaults.headers.common["Authorization"]

// session id persists across page loads (new one on browser refresh)
window.x_session_id = uuidv4()
// correlation id persists on same route (new one on route change)
window.x_correlation_id = uuidv4()

//load custom css
// import '../../css/core.scss'

import Vue from 'vue'
import directives from "./directives";
import Router from 'vue-router'
import Form from 'vform';
import {AlertError, AlertErrors, AlertSuccess, HasError,} from 'vform/src/components/bootstrap5';
import _ from './lodash'
import vmodal from 'vue-js-modal';
import VueContentPlaceholders from 'vue-content-placeholders'
import 'vue-loading-overlay/dist/vue-loading.css';
import Treeselect from '@riophae/vue-treeselect'

import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'

import Datepicker from 'vuejs-datepicker';
import DatePickerV2 from 'vue2-datepicker';
import draggable from "vuedraggable";
import VueI18n from 'vue-i18n';
import translations from './translations.json';

import * as Sentry from "@sentry/vue";
// import {Integrations} from "@sentry/tracing";

import globalMixin from './mixins/globalMixin.js';
import TableHelper from './components/includes/TableHelper.vue';
import ModalFormHelper from './components/includes/ModalFormHelper.vue';
import TablePagination from './components/includes/TablePagination.vue';
import Include from './components/includes/Include.vue';
import Day from './components/includes/Day.vue';
import YesNo from "./components/includes/YesNo.vue";
import TableButton from "./components/includes/TableButton.vue";
import FormCheck from '@cc/includes/FormCheck.vue'
import FormSwitch from '@cc/includes/FormSwitch.vue'
import FormInput from '@cc/includes/FormInput.vue'
import EditableInput from '@cc/includes/EditableInput.vue'
import EditableInputFlat from '@cc/includes/EditableInputFlat.vue'
// import EditableInputHyper from '@cc/includes/EditableInputHyper.vue'
import EditableWrapper from "@cc/includes/EditableWrapper.vue";
import FormTreeselect from '@cc/includes/FormTreeselect.vue'
import FormTreeselect2 from '@cc/includes/FormTreeselect2.vue'
import Select2 from './plugins/select2'
import FormSelect2 from '@cc/includes/FormSelect2.vue'
import NoUiSldier from '@cc/includes/NoUiSlider.vue'
import AddButtonIcon from '@cc/includes/AddButtonIcon.vue';
import FormLabel from '@cc/includes/FormLabel.vue';
import UserName from "@cc/includes/UserName.vue";
import VueColumnsResizable from './plugins/vue-columns-resizable';
import ShowErrorArray from "@cc/includes/ShowErrorArray.vue";
import DrfListErrors from "@cc/includes/DrfListErrors.vue";
import TreeNode from "@cc/includes/TreeNode.vue";
import BsDropdown from "@cc/includes/BsDropdown.vue";
import FieldComponent from "@cc/modules/crm/company/FieldComponent.vue";
import Dropzone from "@plug/dropzone/Dropzone.vue";

import StaleRwWarningAlert from "@cc/includes/StaleRwWarningAlert.vue";

import MainApp from '@cc/App.vue'
import NoAuthApp from '@cc/NoAuthApp.vue'

import BugReportModal from '@cc/split/BugReportModal.vue'

import 'leaflet/dist/leaflet.css';

import router from './routes'

Vue.use(Router)

//plugins
Vue.use(Autocomplete)
Vue.use(VueContentPlaceholders)
Vue.use(VueColumnsResizable);
Vue.use(vmodal, {dialog: true})
Vue.use(Select2)
Vue.use(VueI18n)

Datepicker.methods.showCalendar = function () {
    if (this.disabled || this.isInline) {
        return false;
    }
    if (this.isOpen) {
        return this.close(true);
    } else if (!this.isInline) {
        this.$emit('opened');
    }
    this.setInitialView();
};

//components
Vue.component('dropzone', Dropzone)
Vue.component('draggable', draggable)
Vue.component('treeselect', Treeselect)
Vue.component('form-check', FormCheck)
Vue.component('form-switch', FormSwitch)
Vue.component('form-input', FormInput)
Vue.component('editable-input', EditableInput)
Vue.component('editable-input-flat', EditableInputFlat)
// Vue.component('editable-input-hyper', EditableInputHyper)
Vue.component('editable-wrapper', EditableWrapper)
Vue.component('form-treeselect', FormTreeselect)
Vue.component('form-treeselect2', FormTreeselect2)
Vue.component('form-select2', FormSelect2)
Vue.component('no-ui-slider', NoUiSldier)
Vue.component('day', Day)
Vue.component('yes-no', YesNo)
Vue.component('tbl-btn', TableButton)
Vue.component('include', Include)
Vue.component('table-helper', TableHelper)
Vue.component('modal-form-helper', ModalFormHelper)
Vue.component('table-pagination', TablePagination)
Vue.component('datepicker', Datepicker)
Vue.component('date-picker', DatePickerV2)
Vue.component('add-button-icon', AddButtonIcon)
Vue.component('form-label', FormLabel)
Vue.component('user-name', UserName)
Vue.component('tree-node', TreeNode)
Vue.component('bs-dropdown', BsDropdown)
Vue.component('field-component', FieldComponent)

Vue.component(HasError.name, HasError)
Vue.component(AlertError.name, AlertError)
Vue.component(AlertErrors.name, AlertErrors)
Vue.component(AlertSuccess.name, AlertSuccess)
Vue.component('show-error-array', ShowErrorArray)
Vue.component('drf-list-errors', DrfListErrors)

Vue.component('stale-rw-warning-alert', StaleRwWarningAlert)

Vue.mixin(globalMixin)
const i18n = new VueI18n({
    locale: window.locale || 'en',
    fallbackLocale: 'en',
    messages: translations,
})

window.Form = Form;
window.Form.axios = window.axios

const store = Vue.observable({
    page: 1,
    pager: {
        pageCount: 1,
    },
    CLASSES: {
        _KT_CONTENT_CONTAINER: 'container-fluid',
        KT_CONTENT_CONTAINER: 'container-fluid',
    },
})
Vue.prototype.$store = store;

Vue.prototype.$ = window.$ || window.jQuery
Vue.prototype.$toastr = window.toastr
Vue.prototype.$swal = window.Swal
Vue.prototype.$axios = window.axios
// Vue.prototype.$blockUI = window.blockUI
window._ = _
Vue.prototype.$_ = _

try {

        //   .finally(() => this.endCompLoading());
} catch (e) {
    // alert("JSON parse error")
    console.error(e)
}

//check client module access
Vue.prototype.$hasModuleAccess = function (module) {
    return this.$modules.includes(module)
}

Vue.prototype.$killKTMStore = function () {
    for (const [key, value] of Object.entries(KTUtilElementDataStore)) {
        if (value && value.menu) {
            // KTUtil.data(value.menu.element).remove("menu")
            value.menu.destroy()
        } else {
            // console.log(value)
        }
    }
}

KTUtil.data = function (e) {
    return {
        set: function (t, n) {
            e && (void 0 === e.customDataTag && (window.KTUtilElementDataStoreID++, e.customDataTag = window.KTUtilElementDataStoreID), void 0 === window.KTUtilElementDataStore[e.customDataTag] && (window.KTUtilElementDataStore[e.customDataTag] = {}), window.KTUtilElementDataStore[e.customDataTag][t] = n)
        }, get: function (t) {
            if (e) return void 0 === e.customDataTag ? null : this.has(t) ? window.KTUtilElementDataStore[e.customDataTag][t] : null
        }, has: function (t) {
            return !!e && (void 0 !== e.customDataTag && !(!window.KTUtilElementDataStore[e.customDataTag] || !window.KTUtilElementDataStore[e.customDataTag][t]))
        }, remove: function (t) {
            if(t==='menu'){
                e && this.has(t) && delete window.KTUtilElementDataStore[e.customDataTag]
            }else{
                e && this.has(t) && delete window.KTUtilElementDataStore[e.customDataTag][t]
            }
        }
    }
}

// user permission check for a specific resource's action
// TODO $hasAnyPermission([{resource: '', action: ''}], {user}) and $hasAllPermissions()
Vue.prototype.$hasPermission = function (resource, action, ...args) {
    //ideally, we should lowercase all keys to prevent confusion(?)
    const perm = _.get(this.$permissions[resource], action, null)
    return perm
}

Vue.prototype.$hasClientPermission = function (key, args={}) {
    // defaults to false
    return _.get(this.$clientSettings, key, false)
}

Vue.prototype.$isProperModule = function (module, ...args) {
    const has = module && module == this.$module
    return has
}

Vue.prototype.$isAuth = false

Vue.directive('tooltip', directives.tooltip)
Vue.directive('tooltip-fm', directives.tooltipfm)
Vue.directive('popover', directives.popover)
Vue.directive('modal', directives.modal)
Vue.directive('kt-menu', directives.ktMenu)

checkAuth().then((isAuth) => {
    let App = false

    if(isAuth === 2){
        App = NoAuthApp
        // alert('no_auth')
    }else if(isAuth === 1){
        App = MainApp
        // alert('auth')
    }
    else{
        return
    }

    Sentry.init({
      Vue,
      // dsn not required if sent through a backend path. it can be -> dsn: ''
      // dsn: '',
      dsn: import.meta.env.VITE_SENTRY_DSN,
      enabled: window.sentryEnabled,
      integrations: [],
    //   integrations: [
    //     Sentry.feedbackIntegration({
    //       // Additional SDK configuration goes in here, for example:
    //       colorScheme: "system",
    //       // Disable the injection of the default widget
    //       autoInject: true,
    //       enableScreenshot: true,
    //     }),
    //   ],
      autoSessionTracking: false,
      beforeSend(event, hint) {
        // debugger;
        // if(event?.message === 'manual_bug_report_shortcut'){
        //     return event
        // }
        if (event.tags?.manual) {
            window.sentry_event = event
            return event
            // return null
        }

        // if (event.tags?.report_failure) {
        //     return event
        // }

        return null;
      }
    });

    // const feedback = Sentry.getFeedback();
    // feedback?.attachTo(document.querySelector("#sentry-bug-report-btn"), {
    //     formTitle: "Report a Bug!",
    // });

    window._vapp = new Vue({
        i18n,
        router,
        // directives,
        data() {
            return {
                dynModalData: {
                    hasChanges: false,
                },
                blobList: [],
            }
        },
        mounted() {
        },
        methods: {
            openBugReportModal(){
                this.$modal.show(
                    BugReportModal,
                    {},
                    {
                        height: "auto",
                        scrollable: true
                    }
                );
            },
            async reportSentry(extraData={}){
                let screenshotAttachments = [];
                if (extraData?.screenshots?.length) {
                    screenshotAttachments = await Promise.all(
                        extraData.screenshots.map(async (file, index) => {
                            const buffer = await file.arrayBuffer();
                            return {
                                filename: file.name || `screenshot-${index + 1}.png`,
                                data: new Uint8Array(buffer),
                                contentType: file.type || "image/png",
                            };
                        })
                    );
                }

                Sentry.withScope(scope => {
                    scope.setUser(this.$user);
                    scope.setTag("route", this.$route.path);
                    scope.setTag("correlation_id", window.x_correlation_id);
                    scope.setTag("session_id", window.x_session_id);
                    scope.setTag("build_version", window.x_build_version);
                    // scope.setExtras({ formData: this.form });
                    // const eventId = Sentry.captureException(err);
                    // const eventId = Sentry.captureMessage("manual_bug_report_shortcut", "error");
                    let tags = { manual: true }
                    if (extraData?.tags) {
                        tags = {...tags, ...extraData.tags}
                    }

                    if (extraData?.details) {
                        scope.setExtra("details", extraData.details);
                    }

                    screenshotAttachments.forEach((att) => {
                        scope.addAttachment(att);
                    });

                    const message = `USER_BUG_REPORT::${extraData?.details || ''}`;
                    const eventId = Sentry.captureMessage(message, {
                        level: 'info',
                        tags,
                    });
                    window.sentry_event_id = eventId;
                    console.log("Sentry ID:", eventId);
                    // alert(`Bug reported. You can provide the event ID to an admin for quicker resolution. Event ID: ${eventId}`)
                  });
            },
        },
        render: (h) => h(App)
    }).$mount('#vapp')
});


function getSubdomain(url) {
    const hostname = new URL(url).hostname; // Extracts the hostname (e.g., cavendish.roclo.com)
    const parts = hostname.split('.'); // Split by "."

    return parts.length > 2 ? parts.slice(0, parts.length - 2).join('.') : ''; // Extract subdomain if exists
}

function getModuleSegment(url) {
    const regex = /\/app\/([^\/]+)(\/|$)/;
    const match = url.match(regex);
    return match ? match[1] : '';
}

function constructNewUrl(protocol, baseDomain) {
    const _subdomain = getSubdomain(window.location.href)
    console.warn('sd',_subdomain, protocol, baseDomain)
    return _subdomain ? `${protocol}://${_subdomain}.${baseDomain}` : `${protocol}://${baseDomain}`;
}

async function checkAuth() {
    //return code: 1 -> logged, 2 -> not, 3 -> error

    console.trace("index.js running...");
    console.trace(API_HOST, 'in_idx')

    if (window.location.pathname.startsWith("/app/external/") 
        || window.location.pathname.startsWith("/app/login")){
        console.trace("checkAuth", 2)
        return 2
    }
    
    // OAuth paths should go through authentication check
    // (not excluded here, will check 401 and redirect to login with params)

    const _module = getModuleSegment(window.location.href)

    try {
        const {data} = await axios
            .get('/dashcheck', {
                params: {
                    module: _module,
                }
            })
        
        const oauth_request = window.location.pathname.startsWith("/app/oauth/")

            
        if(data.module_redirect && !oauth_request){
            // alert(data.module_redirect)
            window.location.href = `${BASE_HOST}/app/${data.module_redirect}`
            return 4
        }

        Vue.prototype.$isAuth = true
        Vue.prototype.$user = data.user
        Vue.prototype.$module = data.module?.module
        Vue.prototype.$modules = data.modules
        Vue.prototype.$permissions = data.permissions
        Vue.prototype.$clientSettings = data.client_settings
        Vue.prototype.$vprops = data.vprops
        Vue.prototype.$datagrid = data.datagrid

        return 1
    } catch (err) {
      console.error("Dashcheck failed:", err);
      if(err.response){
        switch (err.response.status) {
            case 400:
              alert("Bad Request: 400.");
              break;
            case 401:
              // If OAuth authorization page, redirect to login with OAuth URL as query param
              if (window.location.pathname.startsWith("/app/oauth/")) {
                // Build full OAuth URL (path + query params)
                const oauthUrl = window.location.pathname + window.location.search
                // Encode the OAuth URL and pass as 'next' query parameter
                const encodedUrl = encodeURIComponent(oauthUrl)
                // Redirect to login with next parameter
                window.location.href = `${window.BASE_HOST || ''}/app/login?next=${encodedUrl}`
                return 2
              }
              return 2
              break;
            case 403:
              alert("Forbidden: You don’t have access.");
              break;
            case 404:
              alert("Not Found: Resource doesn’t exist.");
              break;
            case 500:
              alert("Server Error: Try again later.");
              break;
            default:
              alert(`Error ${err.response.status}:`, err.response.data);
        }
    }
    return 3
    }
}

// Vue.config.errorHandler = function (err, vm, info) {
//     // handle error
//     // `info` is a Vue-specific error info, e.g. which lifecycle hook
//     // the error was found in. Only available in 2.2.0+
//     console.error('eHandlerE', err)
// }